module.exports = __webpack_public_path__ + "static/media/html.ae0cf8ac.svg";